define('webshopProductsDetailBodyImagesTypeView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'buttonView',
  'selectView',
  'webshopProductsDetailBodyImagesTypeListView',
  'template!webshopProductsDetailBodyImagesTypeView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  ButtonView,
  SelectView,
  ListView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'type-view',

    regions: {
      langRegion: '.lang-region',
      addButtonRegion: '.add-button-region',
      listRegion: '.list-region'
    },

    onRender: function () {
      var langs = [{id: '', value: _.i18n('webshop.product.images.allLanguages', null, 'All languages')}];
      _.each(this.options.languages, function (lang) {
        langs.push({id: lang, value: lang.toUpperCase()});
      });

      this.langView = new SelectView({
        collection: new Backbone.Collection(langs)
      });
      this.langRegion.show(this.langView);
      this.langView.$el.attr('title', _.i18n('webshop.product.images.uploadLanguage', null, 'Language of the uploaded images'));

      //----------------------------
      this.addButtonView = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('common.add-image'),
        title: _.i18n('common.add-image')
      });
      this.addButtonRegion.show(this.addButtonView);
      this.addButtonView.on('click', _.bind(this.onAdd, this));

      //----------------------------
      this.listView = new ListView({
        model: this.options.category,
        type: this.model.get('code'),
        languages: this.options.languages,
        getLang: _.bind(function () {
          return this.langView.getValue();
        }, this)
      });
      this.listRegion.show(this.listView);
    },

    serializeData: function () {
      var data = {};

      data.title = this.model.get('label');

      return data;
    },

    onAdd: function () {
      this.listView.add();
    }
  });
});
